import Vue from 'vue';

import NrcDelegateAutocomplete from "@/components/NrcDelegateAutocomplete.vue";
import NrcCustomerAutocomplete from "@/components/NrcCustomerAutocomplete.vue";
import NrcProductAutocomplete from "@/components/NrcProductAutocomplete.vue";
import NrcCompetitorProductAutocomplete from "@/components/NrcCompetitorProductAutocomplete.vue";
import NrcAddressAutocomplete from "@/components/NrcAddressAutocomplete.vue";
import NrcVisitFrequencyAutocomplete from "@/components/NrcVisitFrequencyAutocomplete.vue";
import NrcTeamAutocomplete from "@/components/NrcTeamAutocomplete.vue";
import NrcRoleAutocomplete from "@/components/NrcRoleAutocomplete.vue";

// Register all NRC-prefixed components
Vue.component('nrc-delegate-autocomplete', NrcDelegateAutocomplete);
Vue.component('nrc-customer-autocomplete', NrcCustomerAutocomplete);
Vue.component('nrc-product-autocomplete', NrcProductAutocomplete);
Vue.component('nrc-competitor-product-autocomplete', NrcCompetitorProductAutocomplete);
Vue.component('nrc-address-autocomplete', NrcAddressAutocomplete);
Vue.component('nrc-visit-frequency-autocomplete', NrcVisitFrequencyAutocomplete);
Vue.component('nrc-team-autocomplete', NrcTeamAutocomplete);
Vue.component('nrc-role-autocomplete', NrcRoleAutocomplete);